<script setup lang="ts">
import PdsButton from '@/components/pds/PdsButton.vue';
import { formatDateTime, formatMoney } from '../format';
import { useRoute } from 'vue-router';
import type { HistoryRow } from '../history';
import { orderLink } from '../orderLink';

defineProps<{ rows: HistoryRow[] }>();
const route = useRoute();

const COLUMNS = ['N°', 'Client', 'Commandée', 'État', 'Détail', 'Montant', ''];
const GRID =
  'grid grid-cols-[170px_1fr_1fr_120px_88px_96px] gap-[14px] lg:grid-cols-[180px_1fr_190px_150px_1fr_110px_96px]';
</script>

<template>
  <div class="bg-creux min-w-[760px] rounded-[24px] p-px">
    <div
      :class="GRID"
      class="text-encre-douce h-[30px] items-center px-3 text-[12px] leading-[14px] font-semibold tracking-[0.9px] uppercase max-lg:[&>:nth-child(5)]:hidden"
      role="row"
    >
      <span v-for="column in COLUMNS" :key="column">{{ column }}</span>
    </div>
    <ul class="bg-carte mt-2 overflow-hidden rounded-[23px]">
      <li
        v-for="row in rows"
        :key="row.id"
        :class="GRID"
        class="border-filet-doux h-[62px] items-center border-b px-3 text-[14px] leading-[20px] last:border-b-0 max-lg:[&>:nth-child(5)]:hidden"
        data-testid="history-row"
      >
        <span class="truncate font-semibold">
          #{{ row.orderNumber ?? row.number }}
        </span>
        <span class="truncate">{{ row.label }}</span>
        <span class="text-encre-douce">{{ formatDateTime(row.day) }}</span>
        <span class="font-semibold">{{ row.state }}</span>
        <span class="text-encre-douce truncate text-[12px]">
          {{ row.detail }}
        </span>
        <span :class="row.negative ? 'text-alerte-texte' : ''">
          {{ row.negative ? '−' : '' }}{{ formatMoney(row.amountCents) }}
        </span>
        <PdsButton
          variant="second"
          size="md"
          :to="orderLink(row.id, route.fullPath)"
        >
          Ouvrir
        </PdsButton>
      </li>
    </ul>
  </div>
</template>
